"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkJDO43VGYjs = require('./chunk-JDO43VGY.js');

var o = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h1",
  colorOptions: ["standard"],
  defaultTestId: "h1",
  hasMobileStyles: !0,
  name: "H1",
  typographySpecKey: "heading.100"
}),
    s = exports.b = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h2",
  colorOptions: ["standard"],
  defaultTestId: "h2",
  hasMobileStyles: !0,
  name: "H2",
  typographySpecKey: "heading.200"
}),
    r = exports.c = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h3",
  colorOptions: ["standard"],
  defaultTestId: "h3",
  hasMobileStyles: !0,
  name: "H3",
  typographySpecKey: "heading.300"
}),
    n = exports.d = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h4",
  colorOptions: ["standard"],
  defaultTestId: "h4",
  name: "H4",
  typographySpecKey: "heading.400"
}),
    d = exports.e = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h5",
  colorOptions: ["standard", "weak", "error", "success", "info", "inverse"],
  defaultTestId: "h5",
  name: "H5",
  typographySpecKey: "heading.500"
}),
    p = exports.f = _chunkJDO43VGYjs.b.call(void 0, {
  as: "h6",
  colorOptions: ["standard", "weak", "success", "inverse"],
  defaultTestId: "h6",
  name: "H6",
  typographySpecKey: "heading.600"
}),
    i = exports.g = _chunkJDO43VGYjs.b.call(void 0, {
  as: "span",
  colorOptions: ["standard", "weak", "error", "success", "inverse", "info", "inactive", "disabled", "critical"],
  defaultTestId: "bodyprimary",
  name: "BodyPrimary",
  typographySpecKey: "body.primary"
}),
    c = exports.h = _chunkJDO43VGYjs.b.call(void 0, {
  as: "span",
  colorOptions: ["standard", "weak", "error", "success", "inverse", "info", "inactive", "disabled", "critical"],
  defaultTestId: "bodysecondary",
  name: "BodySecondary",
  typographySpecKey: "body.secondary"
}),
    y = exports.i = _chunkJDO43VGYjs.b.call(void 0, {
  as: "label",
  colorOptions: ["standard", "weak", "disabled"],
  defaultTestId: "labelstrong",
  name: "LabelStrong",
  typographySpecKey: "label.strong"
}),
    l = exports.j = _chunkJDO43VGYjs.b.call(void 0, {
  as: "label",
  colorOptions: ["weak", "disabled", "critical"],
  defaultTestId: "labelmini",
  name: "LabelMini",
  typographySpecKey: "label.mini"
}),
    h = exports.k = _chunkJDO43VGYjs.b.call(void 0, {
  as: "span",
  colorOptions: ["weak", "standard", "inactive", "error", "disabled"],
  defaultTestId: "caption",
  name: "Caption",
  typographySpecKey: "caption.100"
});

exports.a = o;
exports.b = s;
exports.c = r;
exports.d = n;
exports.e = d;
exports.f = p;
exports.g = i;
exports.h = c;
exports.i = y;
exports.j = l;
exports.k = h;